import React from "react";
import "./WitEarnHome.scss"
import insightImage from "../../assets/insights.png"
import SecondaryButton from "../../components/Button/SecondaryButton";
import graph from "../../assets/stats.svg"
import users from "../../assets/users.svg"
import lock from "../../assets/lock.svg"
import InsightsList from "../../components/InsightsList/InsightsList";
import { sortByOrderAscending } from "../../helper/helper";


const WitEarnHomeInsights = ({ components }) => {

    const renderLeftComponent = (key, component) => {
        switch (component.ID) {
            case "HeaderText":
                return <div className="WitEarnHomeInsights-left-header">
                    {component?.Props?.text}
                </div>
            case "HeaderSubText":
                return <div className="WitEarnHomeInsights-left-subheader">
                    {component?.Props?.text}
                </div>
            case "WitEarnHomeInsightsList":
                return <div className="WitEarnHomeInsights-left-list">
                    {component?.Data?.map((insight, index) => {
                        return (
                            <InsightsList key={index} header={insight?.header} subheader={insight?.subheader} icon={insight?.icon} iconColor={insight?.iconColor} />
                        )
                    })}
                </div>
            case "WitEarnHomeInsightsBtnComp":
                return <div className="WitEarnHomeInsights-left-btn-cont">
                    <SecondaryButton buttonText={component?.Props.buttonText} />
                </div>
            default:
                return <div />
        }
    }
    const getLeftComponent = (leftComponents) => {
        return (
            <div className="WitEarnHomeInsights-left">
                {sortByOrderAscending(leftComponents).map((component, key) => {
                    return renderLeftComponent(key, component)

                })}
            </div>
        )
    }

    const getComponents = (key, component) => {
        switch (component.ID) {
            case "WitEarnHomeInsightsLeft":
                return getLeftComponent(component?.Components)
            case "WitEarnHomeInsightsRight":
                return <div className="WitEarnHomeInsights-right">
                    <img alt="" src={component?.Props?.src} />
                </div>
            default:
                return <div />
        }

    }
    return (
        <div className="WitEarnHomeInsights">
            {sortByOrderAscending(components).map((component, key) => {
                return getComponents(key, component)

            })}
        </div>
    )
}
export default WitEarnHomeInsights